module.exports = __webpack_public_path__ + "img/car-active.7f9014da.svg";